$(window).load(function () {
  // Fade out the spinner.
  $('.boutiques_spinner_v1_target').fadeOut();

  // Handle linking to specific sections
  function getParameterByName(name, url) {
    if (!url) {
      url = window.location.href;
    }
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
      results = regex.exec(url);

    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }

    return decodeURIComponent(results[2].replace(/\+/g, ' '));
  }

  // Handle links...?mod[num]=boutique_mod[num]
  function scrollToLinkMod(linkNo) {
    if (getParameterByName('mod' + linkNo) === 'boutique_mod' + linkNo) {
      $('html, body').delay(500).animate({
        scrollTop: $('#dw_waterfresh_mod' + linkNo).offset().top - 100
      }, 1500, 'easeInOutQuad');
    }
  }

  for (i = 2; i <= 4; i++) {
    scrollToLinkMod(i);
  }

  // Fade in and up the hero text
  setTimeout(function () {
    $('.dw_waterfresh_mod1_copy').children().each(function (i) {
      delay = i * 250;
      $(this).delay(delay).animate({
        opacity: 1,
        marginTop: 0
      }, 450, 'easeInOutQuad');
    });
  }, 300);

  // Begin setTimeout at end of animations
  setTimeout(function () {
    setTimeout(function () {
      var target = $('.el_boutique_wrapper:eq(1)').offset().top;

      if ($(window).scrollTop() >= target) {
        return;
      } else {
        $('html, body').animate({
          scrollTop: $('.el_boutique_wrapper:eq(1)').offset().top - 80
        }, 700, 'easeInOutQuad');
      }
    }, 3000);
  }, 2500);
});

(function ($) {
  Drupal.behaviors.dw_waterfresh_formatter = {
    attach: function (context, settings) {
      $('.dw_waterfresh_formatter', context).once('dw_waterfresh_formatter', function () {
        /** SETUP **/
        // Apply classes
        function makeBoutiqueChecks() {
          // Check for Windows.
          if (navigator.platform == 'Win32') {
            $('body').addClass('isWin');
          }

          // Check for Safari.
          if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
            $('body').addClass('isSafari');
          }

          // Check for Firefox.
          var isFF = false;

          if (navigator.userAgent.search('Firefox') >= 0) {
            $('body').addClass('isFF');
            isFF = true;
          }

          // Check for IE.
          var isIE = false;

          if ($('body').hasClass('ie') || $('body').hasClass('ie-11')) {
            isIE = true;
          }
          if (isIE) {
            if ($('body').hasClass('isTouch')) {
              $('body').removeClass('isTouch');
            }
          }

          // Check for mobile device
          var isMobile = false;

          if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            isMobile = true;
            $('body').addClass('isMobile');
          }

          // Check for iPad.
          var isTouch = false;

          if (navigator.userAgent.match(/iPad/i) != null) {
            isTouch = true;
            $('body').addClass('isTouch');
          }
        }
        makeBoutiqueChecks();

        // Hide the hero text for animation
        $('.dw_waterfresh_mod1_copy').children().css({
          'opacity': '0',
          'margin-top': '5%'
        });

        /** ** SCROLLMAGIC FUNCTIONALITY ****/
        // Init scrollMagic Controller Class
        var controller = new ScrollMagic.Controller();

        /** MODULE 4 **/
        // Reset elements
        function resetMod4() {
          $('#dw_waterfresh_mod4').parent().css({
            'opacity': '0',
            'margin-top': '6%'
          });
        }
        resetMod4();

        // Handle single play-through
        var scene4FirstRun = true;

        // Animation
        function scene4() {
          if (scene4FirstRun) {
            $('#dw_waterfresh_mod4').parent().animate({
              opacity: 1,
              marginTop: '0'
            }, 600, 'easeOutQuad', function () {
              scene4FirstRun = false;
            });
          } else {
            return;
          }
        }

        // Init scrollMagic Scene Class
        var sceneTimeline4 = new ScrollMagic.Scene({
          triggerElement: '#dw_waterfresh_mod4',
          offset: -300
        })
          .on('start', function () {
            scene4();
          })
          .addTo(controller);

        /** MPP **/
        // Reset elements
        function resetMPP() {
          $('.mpp').css({
            'opacity': '0',
            'margin-top': '6%'
          });
        }
        resetMPP();

        // Handle single play-through
        var sceneMPPFirstRun = true;

        // Animation
        function sceneMPP() {
          if (sceneMPPFirstRun) {
            $('.mpp').animate({
              opacity: 1,
              marginTop: '0'
            }, 600, 'easeOutQuad', function () {
              sceneMPPFirstRun = false;
            });
          } else {
            return;
          }
        }

        // Init scrollMagic Scene Class
        var sceneTimelineMPP = new ScrollMagic.Scene({
          triggerElement: '.mpp',
          offset: -300
        })
          .on('start', function () {
            sceneMPP();
          })
          .addTo(controller);

        /** OLAPIC **/
        // Reset elements
        function resetOlapic() {
          $('.olapic-widget').css({
            'opacity': '0',
            'margin-top': '6%'
          });
        }
        resetOlapic();

        // Handle single play-through
        var sceneOlapicFirstRun = true;

        // Animation
        function sceneOlapic() {
          if (sceneOlapicFirstRun) {
            $('.olapic-widget').animate({
              opacity: 1,
              marginTop: '0'
            }, 600, 'easeOutQuad', function () {
              sceneOlapicFirstRun = false;
            });
          } else {
            return;
          }
        }

        // Init scrollMagic Scene Class
        var sceneTimelineOlapic = new ScrollMagic.Scene({
          triggerElement: '.olapic-widget',
          offset: -300
        })
          .on('start', function () {
            sceneOlapic();
          })
          .addTo(controller);
        /** ** VIDEO FUNCTIONALITY ****/
        // Players.
        var player1, player2;
        // Video sources.
        var src1 = 'Fkl5kWOT6KY';
        var src2 = 'ESGt8F9NxMw';
        // Initialise YouTube API.
        var tag = document.createElement('script');

        tag.src = 'https://www.youtube.com/iframe_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];

        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

        // Execute as soon as the player API is ready.
        onYouTubeIframeAPIReady = function () {
          player1 = new YT.Player('dw_waterfresh_mod3_video_container', {
            height: '390',
            width: '640',
            videoId: src1,
            playerVars: {
              'autohide': 1,
              'autoplay': 0,
              'color': 'red',
              'cc_load_policy': 0,
              'controls': 0,
              'disablekb': 0,
              'end': 0,
              'wmode': 'transparent',
              'fs': 1,
              'loop': 0,
              'html5': 1,
              'playsinline': 1
            },
            events: {
              'onReady': playerOneReady,
              'onStateChange': onPlayerStateChangeOne
            }
          });
          player2 = new YT.Player('dw_waterfresh_mod4_video_container', {
            height: '390',
            width: '640',
            videoId: src2,
            playerVars: {
              'autohide': 1,
              'autoplay': 0,
              'color': 'red',
              'cc_load_policy': 0,
              'controls': 0,
              'disablekb': 0,
              'end': 0,
              'wmode': 'transparent',
              'fs': 1,
              'loop': 0,
              'html5': 1,
              'playsinline': 1
            },
            events: {
              'onReady': playerTwoReady,
              'onStateChange': onPlayerStateChangeTwo
            }
          });
        };

        // When the Players are ready.
        var duration1, duration2;
        var videoInterval1, videoScrubber1;
        var videoInterval2, videoScrubber2;
        var close1 = $('#dw_waterfresh_mod3 .boutique__video_close_x');
        var close2 = $('#dw_waterfresh_mod4 .boutique__video_close_x');
        var playTrigger1 = $('#dw_waterfresh_mod3 .dw_waterfresh_mod_play');
        var playTrigger2 = $('#dw_waterfresh_mod4 .dw_waterfresh_mod4_play');
        var playPauseBtn;

        function playerOneReady() {
          duration1 = player1.getDuration();
          videoInterval1, videoScrubber1 = $('#dw_waterfresh_mod3_video .boutique__video_inner_scrubber');
        }

        function playerTwoReady() {
          duration2 = player2.getDuration();
          videoInterval2, videoScrubber2 = $('#dw_waterfresh_mod4_video .boutique__video_inner_scrubber_dark');
        }

        // Handle toggle of play/pause.
        function playPause(playerNum, whichBtn) {
          if (whichBtn.hasClass('active')) {
            playerNum.pauseVideo();
            whichBtn.removeClass('active');
          } else {
            whichBtn.addClass('active');
            playerNum.playVideo();
          }
        }

        // Toggle play/pause for first video.
        var playPauseBtn1 = $('#dw_waterfresh_mod3_video .boutique__video_play_btn');

        playPauseBtn1.on('click', function () {
          playPause(player1, playPauseBtn1);
        });

        // Toggle play/pause for second video.
        var playPauseBtn2 = $('#dw_waterfresh_mod4_video .boutique__video_play_btnDark');

        playPauseBtn2.on('click', function () {
          playPause(player2, playPauseBtn2);
        });

        function onPlayerStateChangeOne(event) {
          if (event.data == YT.PlayerState.PLAYING) {
            playPauseBtn1.addClass('active');
          } else if (event.data == YT.PlayerState.PAUSED) {
            playPauseBtn1.removeClass('active');
          }
        }

        function onPlayerStateChangeTwo(event) {
          if (event.data == YT.PlayerState.PLAYING) {
            playPauseBtn2.addClass('active');
          } else if (event.data == YT.PlayerState.PAUSED) {
            playPauseBtn2.removeClass('active');
          }
        }

        // Check for iPad.
        var isTouch = false;

        if (navigator.userAgent.match(/iPad/i) != null) {
          isTouch = true;
          $('body').addClass('isTouch');
        }

        // Check for IE.
        var isIE = false;

        if ($('body').hasClass('ie') || $('body').hasClass('ie-11')) {
          isIE = true;
        }
        if (isIE) {
          if ($('body').hasClass('isTouch')) {
            $('body').removeClass('isTouch');
          }
        }

        // Play the videos.
        function playEach(theNum, eachPlayerNum, eachInterval, eachDuration, eachScrubber, eachClose, eachEnd, src) {
          $('#dw_waterfresh_mod' + theNum + '_video .boutique__video_close_x').show();
          $('#dw_waterfresh_mod' + theNum + '_video .boutique__video_controls_mask').show();
          $('#dw_waterfresh_mod' + theNum + '_video').fadeIn();
          $('#dw_waterfresh_mod' + theNum + '_video .boutique__video_play_btn, #dw_waterfresh_mod' + theNum + '_video .boutique__video_play_btnDark').addClass('active');
          $('#dw_waterfresh_mod' + theNum + '_video_container').show();

          if (isTouch && !isIE) {
            $('#dw_waterfresh_mod' + theNum + '_video .boutique__video_controls_mask').hide();
          }
          scrubberAndPlay(eachPlayerNum, eachInterval, eachDuration, eachScrubber, eachClose, eachEnd);
        }

        playTrigger1.click(function () {
          playEach(3, player1, videoInterval1, duration1, videoScrubber1, close1, 1, src1);
        });

        playTrigger2.click(function () {
          playEach(4, player2, videoInterval2, duration2, videoScrubber2, close2, 1, src2);
        });

        // Handle the scrubber.
        function scrubberAndPlay(playerNum, vidInterval, duration, vidScrubber, close, closeTime) {
          playerNum.seekTo(0, true);
          playerNum.playVideo();

          vidInterval = setInterval(function () {
            var currentTime = playerNum.getCurrentTime(),
              multipliedTime = ((currentTime / duration) * 100) + 3;

            vidScrubber.css('width', multipliedTime + '%');
            if (currentTime >= (duration - closeTime)) {
              close.click();

              return;
            }
          }, 30);
        }

        // Handle fullscreen option.
        function checkFullscreen(fullscreenNo) {
          $('#dw_waterfresh_mod' + fullscreenNo + ' .boutique__video_full_btn, #dw_waterfresh_mod' + fullscreenNo + ' .boutique__video_full_btnDark').click(function () {
            screenfull.request($('#dw_waterfresh_mod' + fullscreenNo + '_video_container')[0]);
          });
        }

        function hideFullscreen(fullscreenNo) {
          $('#dw_waterfresh_mod' + fullscreenNo + ' .boutique__video_full_btn, #dw_waterfresh_mod' + fullscreenNo + ' .boutique__video_full_btnDark').hide();
        }

        if (screenfull.enabled) {
          checkFullscreen(3);
          checkFullscreen(4);
        } else {
          hideFullscreen(3);
          hideFullscreen(4);
        }

        // Close the videos.
        function closePlayer(whichPlayer, playerNum, whichInterval) {
          whichPlayer.pauseVideo();
          whichPlayer.stopVideo();
          $('#dw_waterfresh_mod' + playerNum + '_video_container').hide();
          $('#dw_waterfresh_mod' + playerNum + '_video .boutique__video_close_x').hide();
          $('#dw_waterfresh_mod' + playerNum + '_video .boutique__video_controls_mask').hide();
          $('#dw_waterfresh_mod' + playerNum + '_video .boutique__video_play_btn, #dw_waterfresh_mod' + playerNum + '_video .boutique__video_play_btnDark').removeClass('active');
          clearInterval(whichInterval);
          $('#dw_waterfresh_mod' + playerNum + ' .boutique__video_top_video').fadeOut();
        }

        close1.click(function () {
          closePlayer(player1, 3, videoInterval1);
        });

        close2.click(function () {
          closePlayer(player2, 4, videoInterval2);
        });
      });
    }
  };
})(jQuery);
